var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 16,
    viewBox: "0 0 38 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72801 4.90601H2.49805V9.81193H4.72801V4.90601Z",
    fill: "#0679CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49784 5.35205H0.713867V9.36599H2.49784V5.35205Z",
    fill: "#78BE21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2849 5.79785H35.501V9.81179H37.2849V5.79785Z",
    fill: "#FF6900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.717 10.2576H35.501V5.35165H33.717V10.2576Z",
    fill: "#0679CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.334 2.48877V1.12671L29.3374 1.12671V2.48877H32.334Z",
    fill: "#53A4DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24219 2.06934V0.707275L5.24556 0.707275V2.06934H8.24219Z",
    fill: "#53A4DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74148 4.90601H4.72754V10.2579H8.74148V4.90601Z",
    fill: "#53A4DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2578 10.7039H33.7178V5.35194L29.2578 5.35194V10.7039Z",
    fill: "#53A4DE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6064 5.48515V2.48853H29.0653V5.48515H32.6064Z",
    fill: "#0679CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51465 5.06547V2.06885H4.97346V5.06547H8.51465Z",
    fill: "#0679CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1279 13.4534H17.7417L20.6777 12.1956H24.87V3.38767H20.6777L17.7417 2.12939H13.1279V13.4534Z",
    fill: "#53A4DE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7412 8.4209H20.6772V12.1957L17.7412 13.454V8.4209Z",
    fill: "#024D82"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7412 7.16271H20.6772V3.38875L17.7412 2.13135V7.16271Z",
    fill: "#ADCCF0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6478 2.22998H12.7559V13.3798H13.6478V2.22998Z",
    fill: "#012946"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8638 0H13.2018V15.1638H11.8638C10.9176 15.1638 10.01 14.7879 9.34093 14.1187C8.67181 13.4496 8.2959 12.5421 8.2959 11.5958V3.56794C8.2959 2.62167 8.67181 1.71415 9.34093 1.04503C10.01 0.375907 10.9176 0 11.8638 0Z",
    fill: "#002D62"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3516 2.22998H25.6895C26.6358 2.22998 27.5433 2.60589 28.2125 3.27501C28.8816 3.94413 29.2575 4.85165 29.2575 5.79793V9.81186C29.2575 10.7581 28.8816 11.6657 28.2125 12.3348C27.5433 13.0039 26.6358 13.3798 25.6895 13.3798H24.3516V2.22998Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTc);
export default __webpack_public_path__ + "static/media/TC.9f2955ec234c894d811643bec54fa88f.svg";
export { ForwardRef as ReactComponent };